import { z } from "zod";

export const ProcedureSchema = z.object({
    id: z.number().positive().min(1),
    fieldConfig: z.record(z.union([z.literal(0), z.literal(1), z.literal(2)])).optional(),
    procedureTypeId: z.number().positive().min(1),
    field_config: z.record(z.union([z.literal(0), z.literal(1), z.literal(2)])).optional(),
    activityId: z.number().positive().min(1),
    name: z.string().max(128),
    createdBy: z.number().positive().min(1),
    createdOn: z.date(),
    modifiedBy: z.number().positive().min(1),
    modifiedOn: z.date(),
    description: z.string().max(4096).nullable().optional(),
    ownerId: z.number().positive().min(1),
    startDate: z.preprocess((val) => (typeof val === "string" ? new Date(val) : val), z.date().nullish()),
    endDate: z.preprocess((val) => (typeof val === "string" ? new Date(val) : val), z.date().nullish()),
    canceled: z.boolean(),
    closed: z.boolean(),
    started: z.boolean(),
    stage: z.number(),
    stageType: z.string(),
    lastStage: z.number(),
    contactManagerId: z.number().positive().min(1).nullable().optional(),
});

export type Procedure = z.infer<typeof ProcedureSchema>;
